module.exports = __webpack_public_path__ + "img/subdivide.8bf82508.svg";